<div class="rounded-xl bg-white">
  <div class="flex items-center gap-4 px-4">
    <ng-container
      *ngIf="profileForm.get('profilePicture')?.value; else defaultIcon"
    >
      <img
        class="w-28 h-28 rounded-full"
        [src]="profileForm.get('profilePicture')?.value"
        alt="Profile"
      />
    </ng-container>

    <ng-template #defaultIcon>
      <mat-icon
        class="w-28 h-28 cursor-pointer"
        fontSet="material-symbols-outlined"
      >
        account_circle
      </mat-icon>
    </ng-template>

    <h2 class="text-xl font-semibold">Profile Settings</h2>
  </div>

  <form
    [formGroup]="profileForm"
    class="mt-4 max-h-[450px] overflow-y-auto divide-y"
  >
    <div class="px-4 py-6">
      <!-- Personal Info -->
      <h3 class="font-semibold">Personal Info</h3>
      <div class="mb-2 flex flex-row gap-4">
        <mat-form-field appearance="outline" class="">
          <mat-label>First Name</mat-label>
          <input matInput type="text" formControlName="firstName" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" formControlName="lastName" />
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="w-full mb-2">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>

      <!-- Preferences -->
      <h3 class="mt-4 font-semibold">Preferences</h3>

      <div class="flex justify-between">
        <div class="flex-1 flex-col flex">
          <label class="text-sm font-medium">Weight</label>
          <mat-radio-group
            formControlName="preferredWeightUnit"
            class="flex-col flex"
          >
            <mat-radio-button *ngFor="let unit of weightOptions" [value]="unit">
              {{ unit.toUpperCase() }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="flex-1 flex-col flex">
          <label class="text-sm font-medium">Height</label>
          <mat-radio-group
            formControlName="preferredLengthUnit"
            class="flex-col flex"
          >
            <mat-radio-button *ngFor="let unit of heightOptions" [value]="unit">
              {{ unit.toUpperCase() }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="flex justify-between">
        <div class="flex-1 flex-col flex">
          <label class="text-sm font-medium">Time Format</label>
          <mat-radio-group
            formControlName="preferredTimeFormat"
            class="flex-col flex"
          >
            <mat-radio-button
              *ngFor="let format of timeFormatOptions"
              [value]="format"
            >
              {{ format }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="flex-1 flex-col flex align-baseline justify-end">
          <mat-form-field
            appearance="outline"
            class="w-full"
            style="width: 150px"
          >
            <mat-label>Date Format</mat-label>
            <mat-select formControlName="preferredDateFormat">
              <mat-option
                *ngFor="let format of dateFormatOptions"
                [value]="format"
              >
                {{ format }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div formGroupName="notificationSettings">
        <div class="flex flex-col gap-2">
          <h3 class="mt-4 font-semibold">Notifications</h3>
          <div class="flex flex-row justify-between">
            <label> Receive Email notification: </label>
            <mat-slide-toggle formControlName="isEnabled"> </mat-slide-toggle>
          </div>
          <div class="flex flex-row justify-between">
            <label> Trigger Status changes emails: </label>
            <mat-slide-toggle formControlName="labUserStatusEmailTriggers"> </mat-slide-toggle>
          </div>

        </div>
      </div>
      <div
        formGroupName="profileSettings"
        class="flex flex-col gap-2 border border-gray-300 rounded-md py-4 shadow-sm flex-1"
      >
        <h3 class="mt-4 font-semibold">PDF Preferences</h3>
        <mat-checkbox formControlName="signatureEnabledPdf">
          PDF Signature Enabled
        </mat-checkbox>

        <app-editor
          *ngIf="profileForm.get('profileSettings.signatureEnabledPdf')?.value"
          customClass="!w-full"
          [maxLength]="128"
          label="Signature"
          [content]="profileForm.get('profileSettings.signature')?.value"
          (contentChange)="onSignatureChange($event)"
        ></app-editor>
        <div
          class="min-w-[200px] flex flex-col h- justify-center p-x-4 border border-gray-500 rounded-md shadow-sm flex-1 h-full"
        >
          <label class="text-sm text-gray-600 mb-1">Signature Image</label>
          <app-file-upload
            [aspectRatio]="3/1"
            [resizeToWidth]="300"
            [asset]="signatureImage"
            (uploadSuccess)="onSignatureImageUploadSuccess($event)"
          ></app-file-upload>
        </div>
      </div>

      <!-- Sign-in security is managed centrally, because one set of
           credentials covers every workspace. The button leaves this site;
           it is shown only once the server confirms there is somewhere for
           it to go. -->
      <div
        *ngIf="ssoSecurityAvailable"
        class="mt-4 p-4 border border-gray-300 rounded-md flex items-center gap-4"
      >
        <div class="flex-1">
          <div class="text-sm font-medium">Sign-in security</div>
          <div class="text-xs text-gray-600">
            Two-factor authentication protects your whole Dormotech account,
            across every workspace.
          </div>
        </div>
        <button
          (click)="openSsoSecurity()"
          [disabled]="isOpeningSsoSecurity"
          mat-stroked-button
          color="primary"
          type="button"
        >
          {{ isOpeningSsoSecurity ? "Opening..." : "Secure now" }}
        </button>
      </div>

      <button
        (click)="saveChanges()"
        [disabled]="isLoading"
        mat-flat-button
        color="primary"
        type="submit"
        class="w-full mt-4"
      >
        {{ isLoading ? "Loading..." : "Save Changes" }}
      </button>
    </div>
  </form>
</div>
